import { useEffect, useState } from "react";
import useQuery from "hooks/useQuery";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getOrderDetailsById } from "service/request";
import { StatusName, StatusType } from "config/config";
import useOrderTrackingDetails from "hooks/useOrderTrackingDetails";


const useMapTracking = (setLoading) => {
  const history = useHistory();
  const location = useLocation();
  const [trackingUrl, setTrackingUrl] = useState(null);
  const { queryOrderId, queryTrackUrl, queryBusinessId, queryOcoExternalId, queryBusinessUuid } = useQuery();
  const [canceledByDelivery, setCanceledByDelivery] = useState(false);
  const [canceledByProvider, setCanceledByProvider] = useState(false);
  
  const { orderInfo, activeOrderStep, activeOrderStatus } =
    useOrderTrackingDetails(
      queryOrderId,
      canceledByDelivery,
      setLoading,
      setCanceledByProvider,
      canceledByProvider,
      queryBusinessId,
      queryBusinessUuid
    )

  // const addQueryParam = (key, value) => {
  //   const searchParams = new URLSearchParams(location.search);
  //   searchParams.set(key, value);
  //   const newSearch = searchParams.toString();
  //   history.replace({
  //     pathname: location.pathname,
  //     search: `?${newSearch}`,
  //   });
  // };

  const removeQueryParam = (key) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(key);

    history.replace({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    });
  };

  useEffect(() => {
    if (!queryOrderId || !queryBusinessId || !queryBusinessUuid) return;

    let intervalId;

    const fetchTrackingURI = async () => {
      try {
        const response = await getOrderDetailsById(queryOrderId, queryBusinessId);
        const trackingUrl = response?.data?.data?.taskDetails?.courier?.trackingUrl;
        setTrackingUrl(trackingUrl ?? null);
        if (response?.data?.data?.status === StatusType.CANCELED) {
          setCanceledByProvider(true);
        }
        if (response?.data?.data?.status === StatusType.CANCELED_FROM_PROVIDER) {
          removeQueryParam('tr');
          setCanceledByProvider(true);
        }
      } catch (error) {
        console.error('Error fetching tracking URL:', error);
      }
    };
    fetchTrackingURI().then(() => {});
    intervalId = setInterval(fetchTrackingURI, process.env.REACT_APP_TRACKING_INTERVAL);

    return () => clearInterval(intervalId);
  }, [queryTrackUrl, queryOrderId, queryBusinessId]);

  return {
    queryTrackUrl,
    queryOrderId,
    activeOrderStep,
    orderInfo,
    activeOrderStatus,
    queryOcoExternalId,
    trackingUrl,
    canceledByDelivery,
    canceledByProvider,
  }
}

export default useMapTracking;